<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">车棚时长包管理</h3> 
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create(true, {})"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtnCarport"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <table
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        @click="getList('ID',$event)"
                        style="width: 60px; min-width:60px"
                      >#</th>
                      <th
                        class="text-left sorting"
                        @click="getList('CARPORT_NAME',$event)"
                        style="min-width:100px;"
                      >适用范围</th>
                      <th
                        class="text-left sorting"
                        @click="getList('CAR_TYPE_NAME',$event)"
                        style="min-width:100px;"
                      >车辆类型</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        @click="getList('TYPE',$event)"
                        style="min-width:140px;"
                      >时长包类型</th>
                      <th
                        class="text-left sorting"
                        @click="getList('PACKAGE_NAME',$event)"
                        style="min-width:110px;"
                      >时长包名</th>
                      <!-- <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('VALID_DATE_TYPE',$event)"
                          style="min-width:90px;"
                      >有效期</th>-->
                      <th
                        class="text-left sorting d-xl-table-cell"
                        @click="getList('VALID_TIME',$event)"
                        style="min-width:140px;"
                      >有效时长</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        @click="getList('CHARGE_DESCRIPTION',$event)"
                        style="min-width:120px;"
                      >叠加充电包</th>
                      <!-- <th
                        class="text-left sorting d-xl-table-cell"
                        @click="getList('CHARGE_DURATION ',$event)"
                        style="min-width:150px;"
                      >含每日充电</th>-->
                      <th
                        class="text-left sorting d-xl-table-cell"
                        @click="getList('PAY_MONEY',$event)"
                        style="min-width:100px;"
                      >价格(元)</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        @click="getList('DESCRIPTION_JSON',$event)"
                        style="min-width:120px;"
                      >副标题</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        @click="getList('DESCRIPTION_JSON',$event)"
                        style="min-width:120px;"
                      >标签</th>

                      <!-- <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('CHARGE_DURATION',$event)"
                          style="min-width:170px;"
                      >叠加充电时长(小时)</th>-->
                      <!-- <th
                          class="text-left sorting"
                          @click="getList('PACKAGE_ID',$event)"
                          style="min-width:100px;"
                        >时长包ID</th>

                        <th
                          class="text-left sorting d-md-table-cell"
                          @click="getList('DESCRIPTION_JSON',$event)"
                          style="min-width:120px;"
                        >时长描述</th>

                      -->

                      <th
                        class="text-center d-xl-table-cell sorting"
                        style="width: 130px; min-width:130px"
                        @click="getList('AUTH_TYPE',$event)"
                      >仅白名单用户</th>
                      <th class="text-center d-xl-table-cell" style="width: 80px; min-width:80px">状态</th>
                      <th
                        class="text-center no-print"
                        style="width: 100px;min-width: 100px;"
                        v-if="editBtn || stateBtn"
                      >操作</th>
                    </tr>
                  </thead>
                  <tbody v-if="agents.length">
                    <tr v-for="(agent, i) in agents" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left">{{ agent.CARPORT_NAME }}</td>
                      <td class="text-left">{{agent.CAR_TYPE_NAME}}</td>
                      <td class="text-left">{{agent.TYPE==0?"停车":agent.TYPE==1?"停车+充电":""}}</td>
                      <td class="text-left">{{agent.PACKAGE_NAME}}</td>
                      <!-- <td
                          class="text-left"
                      >{{agent.VALID_DATE_TYPE=="1"?"按月":agent.VALID_DATE_TYPE=="2"?"按天":""}}</td>-->
                      <td
                        class="text-left"
                      >{{agent.VALID_TIME?agent.VALID_TIME:"0"}}{{agent.VALID_DATE_TYPE=="1"?"个月":agent.VALID_DATE_TYPE=="2"?"天":""}}</td>
                      <td class="text-left">{{agent.CHARGE_DESCRIPTION}}</td>
                      <!-- <td
                        class="text-left"
                      >{{agent.CHARGE_DURATION?agent.CHARGE_DURATION+"小时":"无限制" }}</td>-->
                      <td class="text-left">{{changeTwoDecimal(agent.PAY_MONEY)}}</td>
                      <td class="text-left">{{agent.SUB_TITLE}}</td>
                      <td class="text-left">{{agent.TAG}}</td>
                      <!-- <td class="text-left">{{agent.CHARGE_DURATION}}</td> -->

                      <!-- <td class="text-left">{{ agent.PACKAGE_ID }}</td>
                        <td class="text-left d-md-table-cell">{{ agent.SUB_TITLE }}</td>
                        
                        <td class="text-center">
                          <div class="custom-control custom-switch custom-control-primary">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              name="example-sw-primary2"
                              :checked="agent.STATE == 2 ? false : true"
                              disabled
                            />
                            <label
                              class="custom-control-label"
                              :for="'dexample-sw-custom-success-state' + agent.ROWNUM"
                            ></label>
                          </div>
                      </td>-->
                      <td class="text-center">
                        <!-- <div class="custom-control custom-switch custom-control-primary">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            name="example-sw-primary2"
                            :checked="agent.AUTH_TYPE == 0 ? false : true"
                            disabled
                          />
                          <label
                            class="custom-control-label"
                            :for="'dexample-sw-custom-success-state' + agent.ROWNUM"
                          ></label>
                        </div>-->
                        <!-- 0普通，1白名单 -->
                        <i
                          class="fa"
                          :class="agent.AUTH_TYPE == 1 ? 'fa-check-circle text-success' : 'fa-minus-circle text-gray'"
                        ></i>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge badge-pill"
                          :class="agent.STATE == '1' ? 'badge-success' : 'badge-secondary'"
                        >{{ agent.STATE == "1" ? "启用" : "禁用"}}</span>
                      </td>

                      <td class="text-center no-print" v-if="editBtn || stateBtn">
                        <div class="btn-group">
                          <button
                            v-if="editBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            data-toggle="modal"
                            title="查看"
                            @click="create(false, agent)"
                            data-original-title="Edit"
                          >
                            <i class="fa fa-search"></i>
                          </button>
                          <!-- <button
                            v-if="stateBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            data-toggle="tooltip"
                            title="修改状态"
                            @click="createSet(agent)"
                            data-original-title="Edit"
                          >
                            <i class="fa fa-user-cog"></i>
                          </button> -->
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="13">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="agents && agents.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div
      class="modal fade"
      id="modal-default-carport"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-carport"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{created ? '新增车棚时长包' : '停车包费率详情'}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">车棚名称</label>
                <div class="col-sm-12">
                  <el-select
                    @change="changeCarport()"
                    v-model="form.carportId"
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    disabled
                  >
                    <el-option
                      v-for="item in carportList"
                      :key="item.CARPORT_ID"
                      :label="item.CARPORT_NAME"
                      :value="item.CARPORT_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">车辆类型</label>
                <div class="col-sm-12">
                  <el-select
                    v-model="form.carTypeId"
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    disabled
                  >
                    <el-option
                      v-for="item in carTypeList"
                      :key="item.CAR_TYPE_ID"
                      :label="item.CAR_TYPE_NAME"
                      :value="item.CAR_TYPE_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">时长包类型</label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    v-model="form.packageType"
                    disabled
                    @change="changeValIdType()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in packageTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">有效时长</label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.valIdTime" disabled>
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option value="0">每日</option>
                    <option v-for="(item,index) in 12" :key="index" :value="item">{{item}}个月</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">时长包名</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.packageName" maxlength="16" disabled/>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">叠加充电包</label>
                <div class="col-sm-12">
                   <input type="text" class="form-control" disabled v-model="chargePackagName"  />
                  <!-- <select class="form-control" v-model="form.chargePackageId" disabled>
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in chargePackageIdList"
                      :key="index"
                      :value="item.PACKAGE_ID"
                    >{{item.DESCRIPTION}}</option>
                  </select> -->
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">价格(元)</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    v-model="form.payMoney"
                    maxlength="16"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">副标题</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.subTitle" maxlength="16" disabled/>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">标签</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.label" maxlength="16" disabled/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">仅白名单用户</label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.authType" disabled>
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in authTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <!-- <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit()">保存</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      wehitUserGroups: [],
      typeList: [
        {
          value: "1",
          label: "按月"
        }
        // {
        //   value: "2",
        //   label: "按天"
        // }
      ],
      authTypeList: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "否"
        }
      ],
      packageTypeList: [
        {
          value: "0",
          label: "停车"
        },
        {
          value: "1",
          label: "停车+充电"
        }
      ],
      billtype: [
        {
          value: 1,
          label: "免费"
        },
        {
          value: 2,
          label: "按正常收费"
        }
      ],
      allowType: [
        {
          value: 1,
          label: "允许"
        },
        {
          value: 0,
          label: "不允许"
        }
      ],
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      chargePackageIdList: [],
      pro: "",
      city: "",
      dis: "",
      edit: "",
      created: false,
      form: {
        carportId: "",
        carTypeId: "",
        sysDuration: "",
        valIdType: "",
        payMoney: "",
        valIdTime: "",
        packageName: "",
        describe: "",
        label: "",
        remark: "",
        id: "",
        packageType: "",
        duration: "",
        authType: "",
        subTitle: "",
        chargePackageId: ""
      },
      packageId: "",
      clipboard: null,
      sorting: "",
      orderBy: false,
      carportList: [],
      carTypeList: [],
      packageList: [],
      chargePackagName:"",
      addBtn: Util.isHavePerm("carPort/insertCarportCarRate"),
      editBtn: Util.isHavePerm("carPort/updateCarPortCarRate"),
      stateBtn: Util.isHavePerm("carPort/updateCarPortCarRateState")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    "form.carportId": {
      handler: function(val, oldVal) {
        this.searchPackge();
      },
      immediate: true,
      deep: true
    },
    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    },
    "form.sysDuration"(val, oldVal) {
      this.form.sysDuration = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.payMoney"(val, oldVal) {
      this.form.payMoney = Util.testNumberFn(val, "inputChangeTwoDecimal");
    },
    "form.valIdTime"(val, oldVal) {
      if (this.created && val) {
        if (val == "0") {
          this.form.packageName = "日租包";
        } else {
          this.form.packageName = val + "个月";
        }
      }
    }
  },
  mounted() {
    this.getList();
    this.copy();
    this.getProvince();
    this.searchCarport();
    this.searchCarType();
    // this.searchPackge();
  },
  methods: {
    changeCarport() {
      this.form.sysDuration = "";
      this.$http
        .get(
          `${Util.searchURL}/Carport/SearchByChargePackage/${this.form.carportId}`
        )
        .then(
          res => {
            if (res.data.code === 200) {
              this.chargePackageIdList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changeValIdType() {
      if (this.form.packageType == 0) {
        this.form.duration = "";
      }
    },
    searchCarport() {
      this.$http.get(`${Util.searchURL}/Carport/ListByAll?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carportList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    searchCarType() {
      this.$http.get(`${Util.searchURL}/Carport/SearchByCarType?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carTypeList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    searchPackge() {
      if (this.form.carportId == "") return;
      this.$http
        .get(
          `${Util.searchURL}/Carport/SearchByChargePackage/${this.form.carportId}?key=`
        )
        .then(
          res => {
            if (res.data.code === 200) {
              this.packageList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    showType(str) {
      switch (str) {
        case "1":
          return "按卡号";
        case "2":
          return "按用户";
        case "3":
          return "按RFID";
        case "4":
          return "按用户失效时间";
      }
    },
    create(bool, item) {
      jQuery("#modal-default-carport").modal("show");
      if (bool) {
        this.created = true;
        this.packageId = "";
        this.form = {
          carportId: "",
          carTypeId: "",
          sysDuration: "",
          valIdType: "",
          payMoney: "",
          valIdTime: "",
          packageName: "",
          describe: "",
          label: "",
          remark: "",
          id: "",
          packageType: "",
          duration: "",
          authType: "",
          subTitle: "",
          chargePackageId: ""
        };
      } else {
        this.created = false;
        this.getDetail(item.ID);
      }
    },
    getDetail(id) {
      this.$http.get(`${Util.searchURL}/Package/GetSystemStopInfo/${id}`).then(
        res => {
          if (res.data.code === 200) {
            let d = res.data.data;
            this.packageId = d.PACKAGE_ID;
            this.form = {
              carportId: d.CARPORT_ID,
              describe: d.SUB_TITLE,
              label: d.TAG,
              packageName: d.TITLE,
              billingType: d.BILLING_TYPE,
              valIdType: d.VALID_DATE_TYPE,
              carTypeId: d.CAR_TYPE_ID,
              sysDuration: d.CHARGE_PACKAGE_ID,
              payMoney: Util.changeTwoDecimal(d.PAY_MONEY),
              valIdTime: d.VALID_TIME,
              remark: d.REMARK,
              id: d.ID,
              packageType: d.TYPE,
              duration: d.CHARGE_DURATION,
              authType: d.AUTH_TYPE,
              subTitle: d.SUB_TITLE,
              chargePackageId: d.CHARGE_PACKAGE_ID
            };
            this.chargePackagName=d.CHARGE_DESCRIPTION
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    showModal(id, value) {
      $(`#modify${id}`).click(_ => {
        this.created = false;
        this.form = {
          remark: value.REMARK,
          billingType: value.BILLING_TYPE == "免费" ? 1 : 2,
          groupId: value.GROUP_ID
        };
      });
    },
    submit() {
      let url = "";
      if (this.created) {
        url = `${Util.operateURL}/carPort/insertCarportCarRate`;
      } else {
        url = `${Util.operateURL}/carPort/updateCarPortCarRate`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            jQuery("#modal-default-normal").modal("hide");
            Util.message("succ", res.data.desc);
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    createSet(val) {
      this.del = val.STATE == 1 ? 2 : 1;
      let text = this.del == 2 ? "确定禁用？" : "确定启用？";
      swal(text, {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.$http
              .post(`${Util.operateURL}/carPort/updateCarPortCarRateState`, {
                id: val.ID,
                state: this.del
              })
              .then(
                res => {
                  if (res.data.code == 200) {
                    Util.message("succ", res.data.desc);
                    this.getList();
                  } else {
                    Util.message("err", res.data.desc);
                  }
                },
                err => {
                  console.log(err);
                }
              );
            break;
        }
      });
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }
      this.$http
        .get(
          `${Util.searchURL}/Package/SystemStopListBy/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    provinceSel() {
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${this.pro}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      this.$http.get(`${Util.searchURL}/District/ListByCity/${this.city}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      this.$http
        .get(
          `${Util.searchURL}/Package/SystemStopListBy/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[1].innerText;
      var btn = document.getElementById("copybtnCarport");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>